import React from "react";
import ReactDOM from "react-dom/client";
import "./global.css";

import App from "./App";
import { preRenderQueries, queryClient } from "@/services/ApiOps";
import { QueryClientProvider } from "react-query";
import { ping, ring2 } from "ldrs";

ring2.register();
ping.register();

const root = ReactDOM.createRoot(document.getElementById("root")!);
preRenderQueries().then((r) => r);

// Setup MSW mock server in development
if (process.env.NODE_ENV === "development") {
  // Certify MSW's Service Worker is available before start React app.
  import("../mocks/browser")
    .then(async ({ worker }) => {
      return worker.start();
    }) // Run <App /> when Service Worker is ready to intercept requests.
    .then(() => {
      root.render(
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>,
      );
    });
  // Never setup MSW mock server in production
} else if (process.env.NODE_ENV === "production") {
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  );
}
